// extracted by mini-css-extract-plugin
export default {"subMenuList":"subMenuList-IDN03","newSubMenuLabel":"newSubMenuLabel-OyhvM","subMenuItem":"subMenuItem-sI8jN","subMenuLink":"subMenuLink-pbRfP"};